const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;
const STYLES = new Set(['lo-fi', 'cinematic', 'electronic', 'acoustic']);

export function readExtensionHandoff(value) {
  const url = new URL(value, 'https://musicmint.ai');
  if (url.searchParams.get('utm_source') !== 'musicmint_extension') return null;
  const fragment = new URLSearchParams(url.hash.slice(1));
  const prompt = fragment.get('mm_prompt')?.trim();
  const videoId = fragment.get('mm_video_id');
  if (url.pathname.endsWith('/create') && prompt && prompt.length <= 300) {
    return { kind: 'compose', prompt, instrumental: fragment.get('mm_instrumental') !== '0', style: STYLES.has(fragment.get('mm_style')) ? fragment.get('mm_style') : '' };
  }
  if (url.pathname.endsWith('/vocal-separation') && VIDEO_ID.test(videoId || '')) {
    return { kind: 'separate', videoId, url: `https://www.youtube.com/watch?v=${videoId}` };
  }
  return null;
}

export function consumeExtensionFragment() {
  const handoff = readExtensionHandoff(window.location.href);
  if (handoff) {
    const url = new URL(window.location.href);
    url.hash = '';
    window.history.replaceState(window.history.state, '', url.href);
  }
  return handoff;
}

export function extensionDownloadContext(query) {
  const videoId = typeof query.v === 'string' && VIDEO_ID.test(query.v) ? query.v : null;
  return { videoId, type: query.type === '2' ? 2 : 1, videoUrl: videoId ? `https://www.youtube.com/watch?v=${videoId}` : null };
}
